import { render, staticRenderFns } from "./screen4.vue?vue&type=template&id=2e4be3d0&scoped=true&"
import script from "./screen4.vue?vue&type=script&lang=js&"
export * from "./screen4.vue?vue&type=script&lang=js&"
import style0 from "./screen4.vue?vue&type=style&index=0&id=2e4be3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4be3d0",
  null
  
)

export default component.exports